import * as actions from '@/modules/users'

export const fetchUsers = async ({ dispatch, rootGetters }) => {
  if (rootGetters['fetching/isFetching']('users')) {
    return await rootGetters['fetching/getRequest']('users');
  }

  const request = actions.fetchUsers();

  const response = await dispatch('fetching/doRequest', { id: 'users', request }, { root: true })

  response.data.forEach(data => dispatch('upsertUser', data))

  return response;
}

export const fetchUser = async ({ dispatch, rootGetters }, id) => {

  if (rootGetters['fetching/isFetching'](id)) {
    return await rootGetters['fetching/getRequest'](id);
  }

  const request = actions.fetchUser(id);

  const response = await dispatch('fetching/doRequest', { id, request }, { root: true })

  dispatch('upsertUser', response.data)

  return response;
}

export const createUser = async ({ dispatch }, data) => {

  const response = await actions.createUser(data);

  dispatch('upsertUser', response.data)

  return response;
}

export const updateUser = async ({ dispatch }, { id, ...data }) => {

  const response = await actions.updateUser(id, data);

  dispatch('upsertUser', response.data)

  return response;
}

export const deleteUser = async ({ dispatch, commit, rootGetters }, id) => {
  const requestId = `delete_${id}`;

  if (rootGetters['fetching/isFetching'](requestId)) {
    return await rootGetters['fetching/getRequest'](requestId);
  }

  const request = actions.deleteUser(id);

  const response = await dispatch('fetching/doRequest', { id:  requestId, request }, { root: true })

  commit('removeOne', id)

  return response;
}

export const toggleActive = async ({ dispatch, rootGetters }, id) => {
  const requestId = `toggle_active_${id}`;

  if (rootGetters['fetching/isFetching'](requestId)) {
    return await rootGetters['fetching/getRequest'](requestId);
  }

  const request = actions.toggleActive(id);

  const response = await dispatch('fetching/doRequest', { id:  requestId, request }, { root: true })

  dispatch('upsertUser', response.data)

  return response;
}

export const upsertUser = async ({ commit }, data) => {

  const { ...user } = data;

  commit('upsertOne', user)
}

export default {
  fetchUsers,
  fetchUser,
  createUser,
  updateUser,
  deleteUser,
  toggleActive,
  upsertUser
}
